import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import CouponTable from "../configuration/coupon/CouponTable";
import StaticBanner from "./staticBanner/staticBanner";
import Highlights from "./Highlights/Highlights";
import Greeting from "./Greeting/Greeting";
import WalletRedeemPoints from "./walletSettings/WalletSettingsConfig";
import Subscription from "./Subscription/Subscription";

function PromotionalTab() {
  // Tab values: "1" = Coupon, "2" = Static Banner, "3" = Highlight Order
  const [tabValue, setTabValue] = useState("1");

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={tabValue}>
        <Box
          className="tabBoxStyle contentBoxStyle"
          sx={{ width: "100%",
             overflowX: { xs: "auto", sm: "visible" },
            "&::-webkit-scrollbar": { display: "none" },
          }}
        >
          <TabList
            onChange={handleTabChange}
            aria-label="promotional tabs"
            variant="scrollable"
            scrollButtons="auto"
            TabIndicatorProps={{
              style: { backgroundColor: "white" },
            }}
          >
            <Tab label="Coupon" value="1" className="tabStyle" />
            <Tab label="Static Banner" value="2" className="tabStyle" />
            <Tab label="Highlight Order" value="3" className="tabStyle" />
            <Tab label="Greetings" value="4" className="tabStyle" />
            <Tab label="Wallet Points Management" value="5" className="tabStyle" />
            <Tab label="Subscription" value="6" className="tabStyle" />
          </TabList>
        </Box>

        <TabPanel value="1" sx={{ p: 0 }}>
          <CouponTable />
        </TabPanel>
        <TabPanel value="2" sx={{ p: 0 }}>
          <StaticBanner />
        </TabPanel>
        <TabPanel value="3" sx={{ p: 0 }}>
          <Highlights setTabValue={setTabValue}></Highlights>
        </TabPanel>
        <TabPanel value="4" sx={{ p: 0 }}>
          <Greeting/>
        </TabPanel>
        <TabPanel value="5" sx={{ p: 0 }}>
          <WalletRedeemPoints/>
        </TabPanel>
        <TabPanel value="6" sx={{ p: 0 }}>
          <Subscription/>
        </TabPanel>
      </TabContext>
    </Box>
  );
}

export default PromotionalTab;